import styles from "./ChartLegend.module.css";

export interface LegendItem {
  label: string;
  color: string;
  value?: string | number;
}

export interface ChartLegendProps {
  items: LegendItem[];
  direction?: "horizontal" | "vertical";
}

export function ChartLegend({
  items,
  direction = "horizontal",
}: ChartLegendProps) {
  return (
    <div
      className={styles.container}
      data-direction={direction}
    >
      {items.map((item) => (
        <div key={item.label} className={styles.item}>
          <span
            className={styles.swatch}
            style={{ backgroundColor: item.color }}
          />
          <span className={styles.label}>{item.label}</span>
          {item.value !== undefined && (
            <span className={styles.value}>{item.value}</span>
          )}
        </div>
      ))}
    </div>
  );
}
